module.exports = __webpack_public_path__ + "img/ch38.76de33d2.png";